import { useState, useEffect } from "react"
import { Box, Th, Tr, HStack, Button, Text, MenuItem, Checkbox, CheckboxGroup, Input, 
    VStack, Td, Badge, Avatar, useDisclosure, MenuDivider, Center
} from "@chakra-ui/react"
import { TableAsset, MenuAsset, SearchListAsset} from "@utils/assets"
import { formatDate, localNumber, statusColors, truncateText} from "@utils/helpers"
import { RiMoreLine, RiMoreFill} from "@remixicon/react"
import { Link } from "react-router-dom"
import countries from "@utils/countries.json"

const ShippingFeesList = ({shipping, onFeeOpen, setCountry}) => {
    
    const [filter, setFilter] = useState([])
    const filters = shipping?.fees?.map((countryFees) => countryFees?.country);

    const fees = shipping?.fees
        ?.filter((countryFees) => !filter.length || filter.includes(countryFees?.country))
        .flatMap((countryFees) =>
            countryFees?.fees?.map((fee) => ({
                country: countryFees?.country,
                state: fee?.state,
                lgas: fee?.lgas.join(", "), // Combine lgas into a comma-separated string
                fee: fee?.fee,
            }))
        );

    const { results, SearchView, setItems } = SearchListAsset(fees)

    useEffect(() => {
        
        if (shipping) {            
            setItems(fees)
        }

    }, [shipping, filter])

    const FilterView = () => (
        <HStack className="justify-between items-center w-full py-2" spacing={5}>

            <HStack spacing={5}>
            
                <MenuAsset
                    triggerProps={{className: '!text-xs', size: 'sm'}}
                    trigger={Button}
                    triggerContent={<Text>Country</Text>}

                    menuContent={
                        <CheckboxGroup onChange={(value) => setFilter(value)} value={filter?.status}>
                            {
                                filters?.map((filter, index) => (
                                    <MenuItem key={index}>
                                        <Checkbox value={filter} size={'lg'}><Text className="text-xs font-medium capitalize">{filter}</Text></Checkbox>
                                    </MenuItem>
                                ))
                            }
                        </CheckboxGroup>
                    }
                />

            </HStack>

            <Box className="lg:block hidden" spacing={5}>

                {SearchView({placeholder: 'Search for fees'})}
                
            </Box>

        </HStack>
    )

    const TableView = () => (
        <TableAsset
            tableProps={{className: 'border-t'}}
            headerContent={
                <Tr>
                    <Th className="!py-3 !text-gray-400 !font-normal !capitalize !border-0">ID</Th>
                    <Th className="!py-3 !text-gray-400 !font-normal !capitalize !border-0">Country</Th>
                    <Th className="!py-3 !text-gray-400 !font-normal !capitalize !border-0">State</Th>
                    <Th className="!py-3 !text-gray-400 !font-normal !capitalize !border-0">LGAs / Cities</Th>
                    <Th className="!py-3 !text-gray-400 !font-normal !capitalize !border-0">Fee</Th>
                    <Th isNumeric className="!py-3 !text-gray-400 !font-normal !capitalize !border-0">Action</Th>
                </Tr>
            }
            bodyContent={
                <>
                   {
                        results?.map((fee, index) => (

                            <Tr key={index} className="font-medium text-xs">
                                <Td>{index+1}</Td>
                                <Td>{fee?.country}</Td>
                                <Td>{fee?.state}</Td>
                                <Td>{truncateText({text: fee?.lgas, length: 50})}</Td>
                                <Td>₦{localNumber({number: fee?.fee })}</Td>
                                <Td isNumeric>
                                    <Button size={'sm'} className="!text-xs" onClick={() => {
                                        setCountry(fee?.country)
                                        onFeeOpen()
                                    }}>Edit</Button>
                                </Td>
                            </Tr>

                        ))
                    }
                </>
            }
        />
    )

    return (
        <Box>   
            
            {FilterView()}

            {TableView()}
            
        </Box>
    )

}


export default ShippingFeesList